import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIconProps } from '../useIconProps';

var Back = function Back(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.648 8.501l2.705 2.705a.48.48 0 11-.679.679L3.247 8.458l-.002-.002-.099-.099a.5.5 0 010-.707l.104-.103.002-.002L6.656 4.14a.48.48 0 01.679.678L4.653 7.501h7.64a.5.5 0 010 1H4.648z"
  }));
};

Back.displayName = 'Back';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Back.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Back;